import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import Swal from 'sweetalert2'
import { unidadeNegocioTransformer } from '@/utils/transformers'
import { UnidadeNegocio } from '@/models/UnidadeNegocio'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const LOAD_GESTORES = 'LOAD_GESTORES'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    gestores: [],
    roles: [],
    isEditing: false,
    step: 1,
    loading: true,
    dialog: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
  gestores: state => state.gestores,
  isEditing: state => state.isEditing,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit('SET_STATE', { loading: true })
    dispatch('form/BOOTSTRAP_FORM', { model: new UnidadeNegocio() }, { root: true })
    await dispatch(LOAD_GESTORES)
    if (id) {
      commit(SET_STATE, { dialog: false, isEditing: true })
      await api.getEntidade('unidadeNegocio', id).then(response => {
        commit(SET_STATE, { loading: false })
        dispatch('form/BOOTSTRAP_FORM', { model: new UnidadeNegocio(unidadeNegocioTransformer(response.data)) }, { root: true })
      })
    } else {
      commit(SET_STATE, { dialog: true, loading: false, isEditing: false })
    }
  },
  async [LOAD_GESTORES] ({ dispatch, commit }) {
    await api.listEntidade('gestor').then(
      gestores => {
        commit(SET_STATE, { gestores })
      },
    )
  },
  async [SUBMIT] ({ commit, dispatch, state, rootState }, { router, user }) {
    Swal.fire({
      title: 'Cadastrando Unidade de Negócio!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        const form = { ...rootState.form.data };
        (() => {
          return state.isEditing
            ? api.salvarEntidade(form, 'unidadeNegocio', form.id)
            : api.cadastrarEntidade(form, 'unidadeNegocio')
        })().then(
          data => {
            Swal.fire({
              title: state.isEditing
                ? 'Unidade de Negócio atualizada com sucesso!'
                : 'Unidade de Negócio cadastrada com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            })
            dispatch('unidadesNegocio/BOOTSTRAP', null, { root: true })
            router.push({
              path: `/${user.get().role}/unidadesnegocio`,
            })
          },
          error => {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: error.errors ? error.errors : error.message,
            })
          },
        )
      },
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
